// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module_footer__1xlQg","separator":"Footer-module_separator__-TbNr","info":"Footer-module_info__2KYbr","legalLink":"Footer-module_legalLink__1OdXB"};